"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Conversation/Message/MetaMessage.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _time = require('shared/services/time');
var _consent = require('shared/services/consent');
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);







/* An event in the thread ("… was added to the chat"), left-aligned with the
 * bubbles. Neutral, except the consent status lines: "Waiting for consent"
 * reads amber and "Consent received" green. */
const MetaMessage = ({ text, messageKey, sentAt }) => {
  const tone = _consent.consentLineTone.call(void 0, text)
  return (
    _react2.default.createElement('div', { className: "meta-message", id: messageKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 19}}
      , _react2.default.createElement('span', { className: _classBuilder2.default.call(void 0, 'meta-message--text', tone && `meta-message--text--consent-${tone}`), __self: this, __source: {fileName: _jsxFileName, lineNumber: 20}},  text )
      ,  sentAt && (
        _react2.default.createElement('time', {
          className: "meta-message--time",
          dateTime: sentAt,
          title: _time.formatLongDisplayDate.call(void 0, sentAt), __self: this, __source: {fileName: _jsxFileName, lineNumber: 22}}

          ,  _time.getDayTimeString.call(void 0, sentAt) 
        )
      )
    )
  )
}

exports. default = MetaMessage
